import { render, staticRenderFns } from "./ChamadaVoz.vue?vue&type=template&id=ba162006&"
import script from "./ChamadaVoz.vue?vue&type=script&lang=js&"
export * from "./ChamadaVoz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports